import { useEffect, useLayoutEffect } from "react"
import { useLocation, useNavigationType } from "react-router-dom"

import { useScrollTracker } from "components/scroll-tracker"

export const useScrollRestoration = () => {
  const action = useNavigationType()
  const { pathname } = useLocation()
  const { setActive, scrollMap } = useScrollTracker()

  const savedScrollPos = scrollMap[pathname]

  useEffect(() => {
    setActive(true)

    return () => setActive(false)
  }, [])

  useLayoutEffect(() => {
    if (action === "POP" && typeof savedScrollPos === "number") {
      window.scrollTo(0, savedScrollPos)
    }
  }, [action, pathname, savedScrollPos])
}

export default useScrollRestoration
